import { render } from "./TopicSchema.vue?vue&type=template&id=50b75cec&scoped=true"
import script from "./TopicSchema.vue?vue&type=script&lang=js"
export * from "./TopicSchema.vue?vue&type=script&lang=js"

import "./TopicSchema.vue?vue&type=style&index=0&id=50b75cec&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b75cec"]])

export default __exports__